import React from "react";
import "../../Dashboard/Dashboard.css";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { LogoutConsultant } from "../../../services/authService";
import ConfirmationAlert from "../../AlertComponent/ConfirmationAlert";
import { useState } from "react";

const CSidebar = ({ isOpen, setIsOpen, onSelectMenu }) => {
	const navigate = useNavigate();
	const [confirmAlert, setConfirmAlert] = useState(null);

	const username = Cookies.get("username") || "User";

	//  Logout handler
	const handleLogout = () => {
		setConfirmAlert({
			type: "warning",
			message: "Are you sure you want to logout?",
			style: { color: "black" },
		});
	};

	const handleConfirmLogout = async () => {
		try {
			const UserTokenExpiry = new Date();
			await LogoutConsultant(UserTokenExpiry);
		} catch (error) {
			console.error("Logout failed");
		} finally {
			Cookies.remove("employeeToken");
			Cookies.remove("username");
			window.location.href = "/";
		}
	};

	const handleCancelLogout = () => {
		setConfirmAlert(null); // close alert without logging out
	};
	return (
		<div
			className={`sidebar ${isOpen ? "show" : ""} ${
				window.innerWidth < 768 ? "mobile-sidebar" : ""
			}`}
		>
			<div className="p-4 border-bottom d-flex align-items-center gap-3">
				<img
					src={`https://ui-avatars.com/api/?name=${username}&background=0D47A1&color=fff`}
					className="rounded-circle border border-white"
					width={40}
					alt={username}
				/>

				<div className="profile-text">
					<div className="fw-bold text-white small">Welcome</div>
					<div className="text-white-50 small">{username}</div>
				</div>
			</div>

			<nav className="nav flex-column mt-3 px-3 gap-1">
				<Link
					to=""
					onClick={() => onSelectMenu("dashboard")}
					className="nav-link text-white d-flex align-items-center sidebar-item"
				>
					<i className="bi bi-speedometer2 me-2" />
					<span className="sidebar-label">Dashboard</span>
				</Link>

				<Link
					to="/Consultant/Dashboard/All-Jobs"
					onClick={(e) => {
						onSelectMenu("viewpostedJob");
					}}
					className="nav-link text-white d-flex align-items-center sidebar-item"
				>
					<i className="bi bi-briefcase me-2" />
					<span className="sidebar-label">Jobs</span>
				</Link>
				<Link
					to="/Consultant/Dashboard/Profiles-Shared"
					onClick={(e) => {
						onSelectMenu("cvsend");
					}}
					className="nav-link text-white d-flex align-items-center sidebar-item"
				>
					<i className="bi-send-check me-2" />
					<span className="sidebar-label">Profiles Shared</span>
				</Link>

				<Link
					to="/Consultant/Dashboard/Shortlist-Candidates"
					onClick={(e) => {
						onSelectMenu("shortlistcandidate");
					}}
					className="nav-link text-white d-flex align-items-center sidebar-item"
				>
					<i className="bi-bookmark-check me-2" />
					<span className="sidebar-label">ShortListed</span>
				</Link>

				<Link
					to="/Consultant/Dashboard/Interview-Schedule"
					onClick={(e) => {
						onSelectMenu("interviewscheduled");
					}}
					className="nav-link text-white d-flex align-items-center sidebar-item"
				>
					<i className="bi-calendar-event me-2" />
					<span className="sidebar-label">Interview Scheduled</span>
				</Link>

				<Link
					to="/Consultant/Dashboard/Selected-Candidates"
					onClick={(e) => {
						onSelectMenu("selectedcandidates");
					}}
					className="nav-link text-white d-flex align-items-center sidebar-item"
				>
					<i className="bi bi-patch-check me-2" />
					<span className="sidebar-label">Selected</span>
				</Link>
			</nav>

			<div className="logout px-3 py-2">
				<button
					onClick={handleLogout}
					className="btn btn-light w-100 d-flex align-items-center justify-content-start gap-2"
				>
					<i className="bi bi-box-arrow-right fs-5" />
					<span className="sidebar-label">Logout</span>
				</button>
			</div>

			{confirmAlert && (
				<ConfirmationAlert
					title={confirmAlert.type}
					message={confirmAlert.message}
					onClose={() => setConfirmAlert(null)}
					onConfirm={handleConfirmLogout}
					onCancel={handleCancelLogout}
				/>
			)}
		</div>
	);
};

export default CSidebar;
